import {
  Autocomplete,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as DoorIcon } from "../../assets/DeviceIcon/DoorPic.svg";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import { updateDoor } from "../../slices/VisitorAccessLevels/VisitorAccessLevelSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const SetCheckInCheckOutDoor = (props) => {
  const [open, setOpen] = useState(props.open);
  const [payload, setPayload] = useState({
    parameters: { doorStatus: "" },
    accessLevelName: props?.accessLevelName,
    doorNames: props.updateData?.name,
    instatus: "",
    deviceId: props?.updateData?.deviceId,
  });
  const [selectedValue, setSelectedValue] = useState(null);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (props.updateData.deviceProperty) {
      setPayload((prev) => ({
        ...prev,
        parameters: {
          ...prev.parameters,
          doorStatus: props.updateData.deviceProperty,
        },
        instatus: props.updateData.deviceProperty,
      }));
      setSelectedValue(
        doorProperty.find(
          (prop) => prop.value === props.updateData.deviceProperty,
        ),
      );
    }
  }, [props.updateData.deviceProperty]);

  if (open) {
    setDiaLogBoxBlur(true);
  }
  const handleClose = () => {
    props.onClose(!open);
    setOpen(!open);
    setDiaLogBoxBlur(false);
  };

  const handleChange = (event, newValue) => {
    if (newValue) {
      // setPayload({ parameters: { doorStatus: newValue.value } });
      setPayload((prev) => ({
        ...prev,
        parameters: {
          ...prev.parameters,
          doorStatus: newValue.value,
        },
        instatus: newValue.value,
      }));
      setSelectedValue(newValue);
    } else {
      setPayload({ parameters: { doorStatus: null } });
      setSelectedValue(null);
    }
  };

  const handleUpdate = () => {
    if (!selectedValue) {
      Toast(t("ENTER_DOOR_PROPERTY"), "error");
      return;
    }
    // accessLevelName : props?.accessLevelName

    const state = {
      payload: payload,
      doorId: props.updateData.doorId,
      deviceId: props?.updateData?.deviceId,
    };

    dispatch(updateDoor(state))
      .unwrap()
      .then((data) => {
        if (data.code === "DMSI0000") {
          Toast(t("UPDATE_SUCCESSFULLY"), "success");
          props.reloadlist(true);
          handleClose();
        } else {
          Toast(t("THERE_SOME_ERROR"), "error");
        }
      });
  };

  const doorProperty = [
    { id: "1", value: "checkIn", name: "Check-In" },
    { id: "2", value: "checkOut", name: "Check-Out" },
  ];

  return (
    <div style={{ width: "500px !important" }}>
      <DialogBox
        // Header="Set Check-In/Check-Out door"
        Header={
          <span style={{ fontSize: "21px", color: darkMode ? "#fff" : "" }}>
            {t("Set Check-In/Check-Out door")}
          </span>
        }
        acceptText={t("COMMON007")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        onClose={handleClose}
        cancel={handleClose}
        onSubmit={handleUpdate}
        open={open}
      >
        <Grid container>
          <Grid item lg={11} style={{ marginLeft: "22px", marginTop: "10px" }}>
            <List
              sx={{
                bgcolor: darkMode ? "#36C96D" : "#EFF5F3",
                paddingLeft: "30px",
                borderRadius: "8px",
                color: darkMode ? "#fff" : "",
              }}
            >
              <ListItem>
                <ListItemAvatar sx={{ marginRight: "1rem" }}>
                  <DoorIcon height="75px" width="33px" />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    props.updateData.name
                      ? props.updateData.name
                      : t("DOOR_NAME")
                  }
                />
              </ListItem>
            </List>
          </Grid>
          <Grid item lg={11}>
            <Typography
              padding={"20px 30px"}
              fontSize="14px"
              style={{ color: darkMode ? "#fff" : "" }}
            >
              {t("DEVICEINFO20")}
            </Typography>
          </Grid>
          <Grid item lg={11}>
            <Typography
              style={{
                fontSize: "14px",
                padding: "0px 30px",
                color: "#2281ab",
              }}
            >
              {t("DEVICEINFO21")}
            </Typography>
          </Grid>
          <Grid item lg={11} style={{ margin: "15px 10px" }}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              fullWidth
              disablePortal
              isOptionEqualToValue={(option, value) => option.id === value.id}
              id="door property"
              value={selectedValue}
              getOptionLabel={(option) => option.name}
              options={doorProperty}
              sx={{
                margin: "14px",
              }}
              renderInput={(params) => (
                <CustomTextfield {...params} label={t("Door_properties")} />
              )}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </div>
  );
};
